import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap, catchError } from 'rxjs/operators';
import { PaginationModel, PaginationResult } from '../models/shared-models';
import { NationalUser } from '../models/nationalUser';
import { MemberRollCall } from '../models/memberRollCall';
import { MemberRollCallWrapper } from '../models/memberRollCallWrapper';
import { Event, EventClass, EventEntry, EventRank } from '../models/eventsDto';
@Injectable({
  providedIn: 'root'
})
export class AdministrationService {


  constructor(private httpClient: HttpClient) { }


  public AddOrUpdateNationalUser(value): Observable<any> {

    return this.httpClient.post(environment.apiUrl + 'Administration/AddOrUpdateNationalLoginDetail', value).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }
  
  public GetUsersSetAsActive(role : string = null): Observable<MemberRollCall[]> {
    var url = "Administration/GetUsersToSetActive";

    return this.httpClient.get<MemberRollCall[]>(environment.apiUrl + url).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public GetEventById(eventId: number): Observable<Event> { 
    var url = "Shared/GetEventById?eventId=" + eventId;

    return this.httpClient.get<Event>(environment.apiUrl + url).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public GetEventEntriesByEventId(eventId: number): Observable<PaginationResult<EventEntry[]>> { 
    var url = "Shared/GetEventEntriesByEventId?eventId=" + eventId;

    return this.httpClient.post<PaginationResult<EventEntry[]>>(environment.apiUrl + url, '{}').pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  GetEventEntryById(eventEntryId: number) {
    var url = "Shared/GetEventEntryById?eventEntryId=" + eventEntryId;

    return this.httpClient.get<EventEntry>(environment.apiUrl + url).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  GetEventRankById(id: number) {
    var url = "Administration/GetEventRankById?id=" + id;

    return this.httpClient.get<EventRank>(environment.apiUrl + url).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  GetEventClassById(id: number) {
    var url = "Administration/GetEventClassById?id=" + id;

    return this.httpClient.get<EventClass>(environment.apiUrl + url).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  RemoveEvent(eventId: number) : Observable<any> {
    throw new Error('Method not implemented.');
  }

  AddOrUpdateEvent(value: any) {
    return this.httpClient.post(environment.apiUrl + 'Administration/AddOrUpdateEvent', value).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }

  AddOrUpdateEventRank(value: any) {
    return this.httpClient.post(environment.apiUrl + 'Administration/AddOrUpdateEventRank', value).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }

  AddOrUpdateEventClass(value: any) {
    return this.httpClient.post(environment.apiUrl + 'Administration/AddOrUpdateEventClass', value).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }

  DeleteClass(classId: number) {
    return this.httpClient.post(environment.apiUrl + 'Administration/DeleteEventClassById?id=' + classId, null ).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }

  DeleteRank(rankId: number) {
    return this.httpClient.post(environment.apiUrl + 'Administration/DeleteEventRankById?id=' + rankId, null ).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }


  public UpdateMyDetails(value): Observable<any> {

    return this.httpClient.post(environment.apiUrl + 'User/AddOrUpdateNationalLoginDetail', value).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }



  public GetAllNationalUsers(pagination: PaginationModel): Observable<PaginationResult<NationalUser[]>> {
    let value = JSON.stringify(pagination);
    return this.httpClient.post<PaginationResult<NationalUser[]>>(environment.apiUrl + 'Administration/GetAllUsers',value).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public GetNationalUserById(userId: string) {
    return this.httpClient.get(environment.apiUrl + 'Administration/GetNationalUserById?userId=' + userId).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public GetMyDetails() {
    return this.httpClient.get(environment.apiUrl + 'User/GetMyDetails').pipe(
      tap(),
      catchError(this.handleError)
    );
  }
  public BackupMembers(): Observable<any> {
    return this.httpClient.post(environment.apiUrl + 'Administration/BackupMembers', null).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }

  public ToggleMemberActive(id: string) {
    return this.httpClient.get(environment.apiUrl + 'Administration/ToggleMemberActive?userId=' + id).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public removeMember(userId: string) {
    return this.httpClient.delete(environment.apiUrl + 'Administration/RemoveMember?userId=' + userId).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public SetMembersAsActive(clubId: string, memberIds: string[]) {
    const dto = new MemberRollCallWrapper(clubId, memberIds);
    return this.httpClient.post(environment.apiUrl + 'Administration/SetMembersAsActive', dto).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  public ExportEvent(eventId?: number): Observable<Blob> {
    return this.httpClient.post(environment.apiUrl + 'Administration/ExportEvent?eventId='+eventId,null,
      { responseType: 'blob' });
  }



  private handleError(error: HttpErrorResponse) {
    console.log(error);
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
      errorMessage = error.error.error.errors;
    }
    // return an observable with a user-facing error message
    return throwError(
      errorMessage);
  }
}
